import rewardingTalent from './rewarding_talent.json'

export default rewardingTalent
